export default __webpack_public_path__ + "static/media/map.fb4f57bc.png";